import { useChainId } from 'wagmi'
import { useQuery } from '@tanstack/react-query'
import useConfigManagerRead from '../read/useConfigManagerRead'
import { ContractName, getContractAddress } from '@/constants/contract-addresses'

export type BlockPotTokenData = {
    balance: bigint,
    rewardTrackerAllowance: bigint
}

export default function useNextConfig() {
    const chainId = useChainId()

    const configManager = useConfigManagerRead()
    const mainGameAddress = getContractAddress(chainId, ContractName.LOTTERY_MAIN) // TODO: should be based on the current game

    const { data: nextConfig } = useQuery({
        queryKey: ['nextConfig', chainId],
        queryFn: async () => {
            const gameConfig = await configManager.getNextGameConfig([mainGameAddress])
            const blockPotConfig = await configManager.getNextBlockPotConfig()
            return {
                ...gameConfig,
                ...blockPotConfig
            }
        }
    })
    if (!nextConfig) { return undefined }
    return {
        entryFee: nextConfig.minimumEntryAmount,
        timeBetweenRounds: BigInt(nextConfig.timeBetweenRounds),
        chanceIncrementAmount: BigInt(nextConfig.chanceIncrementAmount),
        chanceMultiplierAmount: BigInt(nextConfig.chanceMultiplierAmount),
        chanceInitialAmount: BigInt(nextConfig.chanceInitialAmount),
        rewardsPercentage: BigInt(nextConfig.rewardsPercentage),
        bountyPercentage: BigInt(nextConfig.bountyPercentage),
        nextPotPercentage: BigInt(nextConfig.nextPotPercentage),
        potAllocations: nextConfig.numAllocs.map((pa) => BigInt(pa)),
        bptDiscount: BigInt(nextConfig.bptDiscount),
        referralDiscount: BigInt(nextConfig.referralDiscount),
        minimumStakeTime: BigInt(nextConfig.minStakeTime)
    }
}